/*
 * ローディング画面を表示するためのUtilクラス
 */

export class LoadingUtil {
    // 参照カウンタ
    private static loadingcount = 0;

    /*
     * ローディング開始
     */
    public static Start(): void {
        // ローディング画面
        if (undefined == LoadingUtil.loadingRef) {
            return;
        }
        LoadingUtil.loadingcount++;
        LoadingUtil.loadingRef.startLoading();
    }

    /*
     * ローディング終了
     */
    public static Stop(): void {
        // ローディング画面
        if (undefined == LoadingUtil.loadingRef) {
            return;
        }

        LoadingUtil.loadingcount--;
        if (0 < LoadingUtil.loadingcount) {
            // 表示中
            return;
        }

        LoadingUtil.loadingRef.stopLoading();
    }

    /*
     * ローディング画面のrefs
     */
    private static loadingRef: any | undefined = undefined;

    /* 
     * ローディング画面の参照を登録
     * ★App.vue意外から呼び出さないこと★
     */
    public static SetLoading(ref: any): void {
        LoadingUtil.loadingRef = ref;
    }
}